export const ASSESSMENT_TYPES = Object.freeze({
  MID_COURSE: 'mid-course',
  PRACTICE: 'practice exam',
  FINAL: 'final exam'
});
